import { render, staticRenderFns } from "./GoalCardText.vue?vue&type=template&id=1feaf5e3&scoped=true"
import script from "./GoalCardText.vue?vue&type=script&lang=js"
export * from "./GoalCardText.vue?vue&type=script&lang=js"
import style0 from "./GoalCardText.vue?vue&type=style&index=0&id=1feaf5e3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1feaf5e3",
  null
  
)

export default component.exports